export default __webpack_public_path__ + "static/media/dynamo-ac.c42d8ba6.svg";